import React, { FC, useRef, useContext, useEffect } from "react";
import CountryOverlays from "../CountryOverlays/CountryOverlays";
import "./CardEntitlement.css";
import { getElementMaximumHeight } from "../../utils/utils";
import CardContext from "../../utils/store/card-context";
import { ComponentMetadata } from "../types";

interface CardEntitlementSchema {
  content: any;
  product: any;
  indexKey: number;
  showEntitleValue: boolean;
  metadata: ComponentMetadata | undefined;
  modalTriggered?: () => void;
}

const CardEntitlement: FC<CardEntitlementSchema> = ({
  content,
  product,
  indexKey,
  showEntitleValue,
  metadata,
  modalTriggered,
}): any => {
  const entitlementSection = useRef<HTMLDivElement>(null);
  const cardContext = useContext(CardContext);
  const findHeight = () => {
    getElementMaximumHeight(
      `linetable-CardEntitlement-entitlementSection${cardContext.indexKey}`,
      cardContext.listLength
    );
  };

  useEffect(() => {
    setTimeout(() => {
      if (entitlementSection?.current) {
        findHeight();
      }
    }, 200);
    window.addEventListener("resize", findHeight);
  }, [content]);
  return (
    <div
      className={"linetable-CardEntitlement-mobileProductEntitlement"}
      id={`linetable-CardEntitlement-entitlementSection${indexKey}${cardContext.indexKey}`}
      ref={entitlementSection}
    >
      <div className={`row ${"linetable-CardEntitlement-entitlementContent"}`}>
        <div className={`${"linetable-CardEntitlement-entitlementValue"} `}>
          <>
            {content?.isblacktheme ? (
              <>
                {content?.blackFridayentitlementIcon?.filename && (
                  <div className={"linetable-CardEntitlement-entitlementIcon"}>
                    <img
                      src={content?.blackFridayentitlementIcon?.filename}
                      width={20}
                      height={20}
                      alt='blackFridayentitlementIcon'
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                {content?.entitlementIcon?.filename && (
                  <div className={"linetable-CardEntitlement-entitlementIcon"}>
                    <img
                      src={content?.entitlementIcon?.filename}
                      width={20}
                      height={20}
                      alt='entitlementIcon'
                    />
                  </div>
                )}
              </>
            )}
            <span
              className={
                "linetable-CardEntitlement-animationTitle entitlementDisplay"
              }
            >
              {content?.entitlementName}
            </span>
          </>
        </div>
        <div className="d-block">
          {content.entitlementDescription && showEntitleValue && (
            <div className={"linetable-CardEntitlement-entitlementDescription"}>
              {content?.entitlementDescription}
            </div>
          )}
          {content?.linkText && (
            <CountryOverlays
              product={product}
              linkText={content?.linkText}
              metadata={metadata}
              modalTriggered={modalTriggered}
              reuseableLineTable={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default CardEntitlement;
